<template>
    <div class="animated fadeIn">
        <div class="title font-300 font-24 mb-15">
            {{ this.$route.name }}
        </div>

        <div class="box">
            <div class="p-15 pb-0">
                <div class="row">
                    <div class="col-6">
                        <a @click="openPage('/class_attendance')" class="btn-grey"><i
                                class="fas fa-arrow-circle-left mr-5"></i>Back</a>
                    </div>
                </div>
            </div>
            <hr class="mb-0">
            <div class="p-15 pt-0">
                <div class="row justify-content-center mt-30">
                    <div class="col-sm-10">
                        <form @submit.prevent="submitAttendance">
                            <b-row class="mb-20">
                                <b-col sm="2">
                                    <label>Club</label>
                                </b-col>
                                <b-col sm="10">
                                    <b-form-select name="branch" v-model="branch_id" @change="changeBranch" v-validate="'required'">
                                        <option :value="null">Please select</option>
                                        <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}
                                        </option>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                            <b-row class="mb-20" v-if="branch_id">
                                <b-col sm="2">
                                    <label>Member</label>
                                </b-col>
                                <b-col sm="10">
                                    <model-select @searchchange="searchMember" :options="optionsMember"
                                        class="border-bottom" name="member" v-validate="'required'"
                                        v-model="addData.member_id"></model-select>
                                    <span class="error">{{ errors.first('member') }}</span>
                                </b-col>
                            </b-row>
                            <!-- <b-row class="mb-20" v-if="branch_id">
                                <b-col sm="2">
                                    <label>Attendance Type</label>
                                </b-col>
                                <b-col sm="10">
                                    <b-form-select name="atten_type" v-model="addData.attendance_type_id"
                                        v-validate="'required'">
                                        <option :value="null">Please select</option>
                                        <option v-for="item in attendance_type" :key="item.id" :value="item.id">
                                            {{ item.name }}</option>
                                    </b-form-select>
                                    <span class="error">{{ errors.first('atten_type') }}</span>
                                </b-col>
                            </b-row> -->
                            <b-row class="mb-20" v-if="branch_id">
                                <b-col sm="2">
                                    <label>Studio</label>
                                </b-col>
                                <b-col sm="10">
                                    <b-form-select name="branch" v-model="studio_id" @change="changeStudio">
                                        <option :value="null">Please select</option>
                                        <option v-for="item in dataStudio" :key="item.id" :value="item.id">{{ item.name }}
                                        </option>
                                    </b-form-select>
                                    <span class="error">{{ errors.first('branch') }}</span>
                                </b-col>
                            </b-row>
                            <b-row class="mb-20" v-if="studio_id">
                                <b-col sm="2">
                                    <label>Class Date</label>
                                </b-col>
                                <b-col sm="10">
                                    <flat-pickr :config="config" v-model="addData.class_date" name="date" class="w-100"
                                        @on-change="changeClassDate" v-validate="'required'"></flat-pickr>
                                    <!-- <b-form-input v-model="addData.created_at" name="email" type="date"></b-form-input> -->
                                    <span class="error">{{ errors.first('date') }}</span>
                                </b-col>
                            </b-row>
                            <b-row class="mb-20" v-if="addData.class_date">
                                <b-col sm="2">
                                    <label>Classes Schedule</label>
                                </b-col>
                                <b-col sm="10">
                                    <div class="custom-search-select">
                                        <model-select :options="dataClassSchedule" class="w-100" name="classes_schedule"
                                            v-validate="'required'" v-model="addData.classes_schedule_id" @input="changeClassesSchedule"></model-select>
                                        <span class="error">{{ errors.first('classes_schedule') }}</span>
                                    </div>
                                </b-col>
                            </b-row>

                            <div class="text-right">
                                <button type="submit" class="btn-primary">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { Auth } from "@/api";
import { quillEditor } from "vue-quill-editor";
import { ModelSelect } from 'vue-search-select'
import moment from 'moment'
import Mixin from '../../mixins/memberMixin'

export default {
    name: "addEvent",
    mixins: [Mixin],
    data: function () {
        return {
            dataClassSchedule: [
                { value: null, text: 'Please select' }
            ],
            dataClassScheduleTemo: [],
            editorOption: {
                // modules: {
                //   toolbar: [
                //     ['bold', 'italic', 'underline', 'strike'],
                //     ['blockquote', 'code-block'],
                //     [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }],
                //   ]
                // }
            },
            config: {
                altInput: true,
                altFormat: 'F j, Y',
                dateFormat: 'Y-m-d'
            },
            // config: {
            //     altInput: true,
            //     altFormat: 'j F Y H:i',
            //     dateFormat: 'Y-m-d H:i',
            //     enableTime: true,
            //     enableSeconds: true,
            //     time_24hr: true
            // },
            imageData: "",
            name: "",
            description: "",
            branch_id: null,
            studio_id: null,
            dataBranch: [],
            dataStudio: [],
            dataClass: [],
            send_date: "",
            classes_id: null,
            promo_code_id: null,
            dataMember: [],
            optionsMember: [
                { value: null, text: 'Please select' }
            ],
            class_schedule: [],
            classes_schedule_id: '',
            attendance_type: [],
            attendance_type_id: '',
            member_id: '',
            status: null,
            file: "",
            options: [
                { value: null, text: "Please select" },
                { value: "active", text: "Active" },
                { value: "inactive", text: "Inactive" }
            ],
            optStudio: [],
            optClasses: [],
            optPromoCode: [],
            addData: {
                attendance_type_id: null,
                classes_schedule_id: null,
                attendance_category_id: 2,
                total_seat: 0,
                booking_status: 1,
                class_days_id: 0,
                member_id: null,
                branch_id: '',
                studio_id: '',
                class_date: '',
                from: 1,
                created_at: ''
            }
        };
    },
    components: {
        ModelSelect,
        quillEditor,
    },
    methods: {
        changeBranch(event) {
            // console.log(this.dataStudio)
            this.addData.branch_id = event
            this.getMember()
            this.getStudio()
        },
        changeStudio(event) {
            // console.log(event)
            if (!this.addData.class_date) {
                this.addData.class_date = new Date().toISOString()
            }
            this.addData.studio_id = event
            this.getClassSchedule()
        },
        changeClassDate(event) {
            this.addData.class_date = moment(event[0]).format('YYYY-MM-DD')
            var set_date_interval = []
            for (var i = 0; i <= 6; i++) {
                set_date_interval[i] = {
                    name: moment(this.addData.class_date).add(i, 'd').format('dddd'),
                    date: moment(this.addData.class_date).add(i, 'd').format('YYYY-MM-DD'),
                    class_days_id: this.getClassDayID(moment(this.addData.class_date).add(i, 'd').format('dddd'))
                }
            }
            // console.log(this.addData.class_date)
            const class_days_id = set_date_interval.find((item) => item.date === this.addData.class_date)
            if (class_days_id) {
                this.addData.class_days_id = class_days_id.class_days_id
                this.getClassSchedule()
            }
        },

        changeClassesSchedule(event) {

            const find = this.dataClassScheduleTemo.find(x => x.id == event)
            this.addData.created_at = this.addData.class_date + ' ' + find.classes_time.time_start
            console.log(this.addData)
        },
        submitAttendance() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    axios.defaults.headers.common[
                        "X-Access-Token"
                    ] = Auth.Session.get().paradigm_token;

                    const data = {
                        member_id: this.addData.member_id,
                        classes_schedule_id: this.addData.classes_schedule_id,
                        attendance_type_id: 1,
                        attendance_category_id: 2,
                        booking_status: 1,
                        created_at: this.addData.created_at
                    }

                    // console.log(data)

                    axios.post('fitness/v1/member_class_attendance/', data).then(response => {
                        this.$router.push('/class_attendance')
                        this.$toast.success('data saved successfully!', 'Success', {
                        position: 'topCenter',
                        icon: 'icon-envelope',
                        progressBarColor: 'rgb(0, 255, 184)',
                        theme: 'dark',
                        backgroundColor: '#565c70',
                        messageColor: '#fff'
                        })
                    }).catch(error => {
                        this.$toast.success('cant saved data!', 'Error', {
                        position: 'topCenter',
                        icon: 'icon-envelope',
                        progressBarColor: 'rgb(0, 255, 184)',
                        theme: 'dark',
                        backgroundColor: '#565c70',
                        messageColor: '#fff'
                        })
                    })
                } else {
                    this.$toast.success("please fill in required fields!", "Error", {
                        position: "topCenter",
                        icon: "icon-envelope",
                        progressBarColor: "rgb(0, 255, 184)",
                        theme: "dark",
                        backgroundColor: "#565c70",
                        messageColor: "#fff"
                    });
                }
            })

        },
        openPage(event) {
            this.$router.push(event);
        },
        fetchData() {
            axios.get('fitness/v1/attendance/attendance_type').then(response => {
                this.attendance_type = response.data.data.rows
            }).catch(error => {
                console.log('error', error)
            })
            axios.get('fitness/v1/branch/').then(response => {
                this.dataBranch = response.data.data.rows
            }).catch(error => {
                console.log('error', error)
            })
        },
        getStudio() {
            axios.get('fitness/v1/studio?status=active&sorting=id&sorting_type=asc&branch_id=' + this.branch_id).then(response => {
                this.dataStudio = response.data.data.rows
            }).catch(error => {
                console.log('error', error)
            })
        },
        getClassSchedule() {
            axios.get(`fitness/v1/classes_schedule/all?branch_id=${this.branch_id}&classes_day_id=${this.addData.class_days_id}&studio_id=${this.addData.studio_id}`).then(response => {
                // console.log(response.data.data.rows)
                var getRealData = response.data.data.rows
                this.dataClassSchedule = [{ value: null, text: 'Please select' }]
                this.dataClassScheduleTemo = []
                for (var i = 0; i < getRealData.length; i++) {
                    var dataComplete = Object.assign({}, { value: null, text: 'Please select' }, { value: getRealData[i].id, text: getRealData[i].class.name + ', ' + getRealData[i].studio.name + ', (' + getRealData[i].classes_day.name + ', ' + (getRealData[i].classes_time.time_end).slice(0, -3) + '-' + (getRealData[i].classes_time.time_end).slice(0, -3) + ')' })
                    this.dataClassSchedule.push(dataComplete)
                    this.dataClassScheduleTemo.push(getRealData[i])
                }
            }).catch(error => {
                console.log('error', error)
            })
        },
        getClassDayID(day_name) {
            switch (day_name) {
                case "Monday":
                    return 1;
                case "Tuesday":
                    return 2;
                case "Wednesday":
                    return 3;
                case "Thursday":
                    return 4;
                case "Friday":
                    return 5;
                case "Saturday":
                    return 6;
                case "Sunday":
                    return 7;
            }
        }
    },
    created: function () {
        this.fetchData()
    }
}


</script>
